import apiService from "../api";

export const getAppointmentServices = () => {
  return apiService("/vaccine/appointments/main-services/", "GET", null, true);
};

export const getAppointmentServicesLocation = (slug: string) => {
  return apiService(
    `/vaccine/appointments/main-services/${slug}/locations/`,
    "GET",
    null,
    true
  );
};

export const getHfLocation = (page: any) => {
  return apiService(
    `/healthfacilities/?page=${page}&size=10`,
    "GET",
    null,
    true
  );
};

export const getVaccines = (category?: string) => {
  return apiService(`/vaccine/?category=${category}`, "GET", null, true);
};

export const getVaccineTabs = (slug: string) => {
  return apiService(
    `/vaccine/appointments/main-services/sub-service/${slug}/`,
    "GET",
    null,
    true
  );
};

export const getVaccineOffering = (slug: string) => {
  return apiService(
    `/vaccine/service/${slug}/service-offering/`,
    "GET",
    null,
    true
  );
};

export const getServiceOfferingOption = (slugId: any) => {
  return apiService(
    `/vaccine/service-offering/${slugId}/options/`,
    "GET",
    null,
    true
  );
};

export const createBookAppointment = (formData: Record<string, any>) => {
  return apiService(`/vaccine/appointments/`, "POST", formData, true);
};

export const payForAppointment = (appointment: number, pin: string) => {
  return apiService(
    `/wallet/booking-payment/`,
    "POST",
    { appointment, pin },
    true
  );
};

export const getAppointments = () => {
  return apiService(`/vaccine/appointments/`, "GET", null, true);
};
